import React, { useContext } from "react";
import { Col, Row, Form, Input, message, Card, Select, Tooltip, Switch, Button, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import "dayjs/locale/en";
import { AuthContext } from "../../Auth/AuthContext";
import { addDesignation } from "../../utils/API";
import { ArrowLeftOutlined } from "@ant-design/icons";
const { Option } = Select;

interface AddDesignationModalProps {
  visible: boolean;
  onClose: () => void;
  onTaskCreated: () => void;
  isOpen?: boolean; // Make it optional if you still want to keep it
}
const AddDesignation: React.FC<AddDesignationModalProps> = ({ visible, onClose, onTaskCreated }) => {
  const navigate = useNavigate();

  const { authData } = useContext(AuthContext);
  const [form] = Form.useForm(); // Use Form hook to get form instance
  const [isLoading, setIsLoading] = React.useState(false);
  const roleId = authData.roleId;

  const handleSubmit = async (values: any) => {
    try {
      setIsLoading(true);
      // console.log("Submitting Data:", values); // ✅ Log data before sending

      const response = await addDesignation(values);

      // console.log("API Response:", response); // ✅ Log API response

      message.success("Designation added successfully!");
      form.resetFields();
      navigate("/designations"); // Redirect after success
    } catch (error) {
      // console.error("API Error:", error); // ✅ Log error details
      message.error("Failed to add designation");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={600}
      centered
      destroyOnClose
      className="custom-modal"
      bodyStyle={{
        overflowY: "auto",
        fontFamily: "inter, sans-serif",
      }}
      styles={{
        header: {
          padding: "12px",
          position: "sticky",
          top: 0,
          backgroundColor: "#f1f5ffff",
        },
        content: {
          padding: 0,
          overflow: "hidden",
        },
      }}
      title={
        <div
          style={{
            color: "#4b5563",
            fontFamily: "inter, sans-serif",
            fontSize: "20px",
            fontWeight: 500,
          }}
        >
          Create New Designation
        </div>
      }
    >
      <Form
        onFinish={handleSubmit}
        form={form}
        layout="horizontal"
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 20 }}
        colon={false}
        style={{ margin: 0 }}
      >


        {/* Designation Name */}
        <div className="elements">

          <Col>

            <Form.Item
              required={false}
              label={<label className="Inputlabel">
                <span style={{
                  color: '#4b5563', // Medium gray color similar to the image
                  fontFamily: 'inter, sans-serif', // Matches the clean sans-serif style
                  fontSize: '14px', // Approximate font size based on the image
                  paddingLeft: "15px",
                  fontWeight: 500, // Medium weight to match "font-medium"
                }}>Designation</span>   <span className="text-danger">*</span>
              </label>}
              name="name"
              rules={[
                {
                  required: true,
                  message: "Please Enter Designation",
                },
              ]}
            // optional to remove default margin
            >
              <Input
                size="large"
                disabled={roleId == 2}
                className="Allinput"
                placeholder="Designation"

              />
            </Form.Item>
          </Col>
        </div>
        {/* Submit Button */}
        <Col
          xs={24}
          sm={24}
          md={24}
          xl={24}
          xxl={20}
          className="d-flex justify-content-end me-3 mt-2"
        >
          <div className="button-wrapper">
            <button
              className="allcanclebutton"
              onClick={onClose}
              disabled={isLoading}
            >
              Cancel
            </button>
            <button className="allsubmitebutton" disabled={isLoading}>
              {isLoading ? "Add..." : "Add"}
            </button>
          </div>
        </Col>


      </Form>

    </Modal>
  );
};

export default AddDesignation;
